import React, { useRef, useState } from 'react'
import {Badge, ImageBuffer, ReadMore, SubCover, SubHeader} from '../..'
import { img1 } from '../../../assets'
import { personalizedCare } from '../../../utils/constants'
import { ArrowForwardRounded } from '@mui/icons-material'

import './personalizedCare.css'

const PersonalizedCare = () => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const modalNavRef                             = useRef<HTMLDivElement | null>(null);
    const [openSubMegaMenu, setOpenSubMegaMenu]   = useState<number | null>(null);
    const [toggleResult, setToggleResult]         = useState<boolean>(false);

    const handleToggleAboutMore = (index: number) => {
        // setToggleResult(true)
        setOpenSubMegaMenu(prev => (prev === index ? null : index));
    }

    const handleCloseCover = () => {
        setToggleResult(false)
        setOpenSubMegaMenu(null);
    }
    
    const closeAboutModal = (e: React.MouseEvent<HTMLElement>) => {
        if(modalNavRef.current === e.target){
            setToggleResult(false)
            setOpenSubMegaMenu(null)
        }
    }

  return (
    <>
        <div id='care' className="personalized-care-wrapper">
            <Badge title="Personalized Care For The Elderly" />
            <SubHeader title="What we do" description="Where Serenity And Professionalism Meet" />
            <div className='personalized-care-container'>
                <div className='personalized-care-image-cover'>
                    <ImageBuffer className="personalized-care-image" src={img1} alt="personalized care"/>
                </div>

                <div className="personalized-care-detail-wrapper">
                    <div className="personalized-care-main-cover">
                        <h1 className="personalized-care-title">
                            <span className="personalized-care-text">Where Serenity And</span> Professionalism Meet.
                        </h1>
                        <p className="personalized-care-sub-title">
                            Services We Offer
                        </p>
                        {personalizedCare.map((result, index) => (
                            <div className="personalized-care-details-cover" key={index} onClick={() => setOpenIndex(openIndex === index ? null : index)}>
                                <div className="personalized-care-details-title">
                                    <h3 className="personalized-care-details-title-text">
                                        {result.question}
                                    </h3>
                                </div>
                                <p className="personalized-care-details-description">
                                    {result.answer}
                                </p>
                            </div>
                        ))}
                        <button className="personalized-care-read-more-btn-cover" onClick={() => handleToggleAboutMore(1)}>
                            <span>Read more</span>
                            <ArrowForwardRounded />
                        </button>
                        <ReadMore onOpen={toggleResult} onClose={closeAboutModal} openSubMegaMenu={openSubMegaMenu} onClickName="Create Result" />
                    </div>
                </div>
            </div>
        </div>
        {openSubMegaMenu !== null && (
            //z-index: 3, others should be higher
            <SubCover handleCloseCover={handleCloseCover} />
        )}
    </>
  )
}

export default PersonalizedCare